import * as yup from 'yup'
import DraftOrderItem, {DraftOrderItemSchema} from './DraftOrderItem'
import {deliveryTypes} from 'app/constant'
import {typesPayment} from '.'

export type DraftOrderState = {
  order: DraftOrder
  customer: any
  isDirty: boolean
  validateWineClubDiscount: boolean
  errors: any[]
  isValid: boolean
  discounts: Record<string, any>
  isEditMode: boolean
  viewDiscounts: Record<string, any>
}

type DraftOrder = {
  id?: string
  customerId: string | any
  shippingAddressId: string | any
  billingAddressId?: string | any
  status: 'OPEN' | 'INVOICE_SENT' | 'COMPLETED'
  name: string
  subtotalPrice: number
  shippingPrice: number
  totalTax: number
  totalDiscounts: number | any
  wineClubDiscounts: number
  totalPrice: number
  items: DraftOrderItem[]
  deletedItems: string[]
  shippingRateId: string | any
  discountCodeId?: string | any
  shippingRate?: any
  paymentMethodId: string | any
  isCompliant: boolean
  orderDeliveryMethod: string
  isFreeShipping?: boolean
  wineClubDiscountCodeId?: string | any
  note: string
  salesTax: number | any
  crv: number | any
  hasWineClub?: boolean
  paymentType: string
  isAutoDiscountRemoved: boolean
  isTaxRemoved: boolean
  orderSubtypeId?: string | null
  orderSubtype?: any
}

export default DraftOrder

export const DraftOrderSchema = yup.object().shape({
  customerId: yup
    .string()
    .required('Please select a customer')
    .typeError('Please select a customer'),
  orderDeliveryMethod: yup
    .string()
    .required('Please select a order delivery method')
    .typeError('Please select a order delivery method'),
  shippingAddressId: yup.string().when('orderDeliveryMethod', {
    is: deliveryTypes.ship,
    then: yup
      .string()
      .required('Please select a shipping address')
      .typeError('Please select a shipping address'),
    otherwise: yup.string().notRequired().nullable(),
  }),
  paymentMethodId: yup.string().when('paymentType', {
    is: (val: string) => {
      return val === typesPayment.card
    },
    then: yup
      .string()
      .required('Please select a billing payment method')
      .typeError('Please select a billing payment method'),
    otherwise: yup.string().notRequired().nullable(),
  }),
  items: yup
    .array()
    .of(DraftOrderItemSchema)
    .min(1, 'Please select at least one product')
    .required('Please select at least one product'),
})

export const shippingMethodErrorMessage = 'Please select a shipping method'
export const OrderSchema = yup.object().shape({
  customerId: yup
    .string()
    .required('Please select a customer')
    .typeError('Please select a customer'),
  billingAddressId: yup.string().when('paymentType', {
    is: (val: string) => val === typesPayment.card,
    then: yup
      .string()
      .required('Please select a billing address')
      .typeError('Please select a billing address'),
    otherwise: yup.string().notRequired().nullable(),
  }),
  paymentMethodId: yup.string().when('paymentType', {
    is: (val: string) => val === typesPayment.card,
    then: yup
      .string()
      .required('Please select a billing payment method')
      .typeError('Please select a billing payment method'),
    otherwise: yup.string().notRequired().nullable(),
  }),
  orderDeliveryMethod: yup
    .string()
    .required('Please select a order delivery method')
    .typeError('Please select a order delivery method'),
  shippingRateId: yup.string().when(['orderDeliveryMethod', 'isFreeShipping'], {
    is: (orderDeliveryMethod: any, isFreeShipping: boolean) => {
      // if (isFreeShipping && orderDeliveryMethod === deliveryTypes.ship) {
      //   return false
      // }
      return orderDeliveryMethod === deliveryTypes.ship
    },
    then: yup.string().required(shippingMethodErrorMessage).typeError(shippingMethodErrorMessage),
    otherwise: yup.string().notRequired().nullable(),
  }),
  shippingAddressId: yup.string().when('orderDeliveryMethod', {
    is: deliveryTypes.ship,
    then: yup
      .string()
      .required('Please select a shipping address')
      .typeError('Please select a shipping address'),
    otherwise: yup.string().notRequired().nullable(),
  }),
  items: yup
    .array()
    .of(DraftOrderItemSchema)
    .min(1, 'Please select at least one product')
    .required('Please select at least one product'),
})

export const orderStatus = {
  completed: 'COMPLETED',
}

export const draftOrderInitialState: DraftOrderState = {
  order: {
    customerId: '',
    shippingAddressId: '',
    name: '',
    subtotalPrice: 0,
    shippingPrice: 0,
    totalTax: 0,
    totalDiscounts: 0,
    wineClubDiscounts: 0,
    totalPrice: 0,
    status: 'OPEN',
    items: [],
    deletedItems: [],
    shippingRateId: '',
    paymentMethodId: null,
    isCompliant: false,
    billingAddressId: '',
    orderDeliveryMethod: '',
    note: '',
    salesTax: 0,
    crv: 0,
    paymentType: 'CARD',
    isAutoDiscountRemoved: false,
    isTaxRemoved: false,
    orderSubtypeId: null,
  },
  customer: null,
  isDirty: false,
  errors: [],
  isValid: false,
  isEditMode: false,
  validateWineClubDiscount: false,
  discounts: {},
  viewDiscounts: {},
}
